import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import {
    PLANNING_TASK_STATUTS,
    PLANNING_TASK_STATUT_LABELS,
} from '../utils/equipePlanningConstants';
import { taskCardCompactLabel } from '../utils/equipePlanningApi';
import '../styles/MonPlanningRecap.css';

/**
 * Menu de changement de statut d'une tâche planning (portal).
 * Utilisé par « Mon planning » (employé) et « Planning — assignation » (manager).
 * Fermé par clic extérieur ou Échap.
 */
const PlanningStatusMenu = ({ task, anchorRect, onPick, onClose }) => {
    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose(); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [onClose]);

    if (!anchorRect) return null;
    const width = 172;
    const left = Math.min(
        Math.max(8, anchorRect.left + anchorRect.width / 2 - width / 2),
        window.innerWidth - width - 8,
    );
    const below = window.innerHeight - anchorRect.bottom > 190;
    const style = below
        ? { top: anchorRect.bottom + 6, left, width }
        : { bottom: window.innerHeight - anchorRect.top + 6, left, width };

    return createPortal(
        <>
            <div className="mpr-statusmenu-backdrop" onClick={onClose} aria-hidden="true" />
            <div className="mpr-statusmenu" style={style} role="menu" aria-label="Changer le statut">
                <p className="mpr-statusmenu-title">{taskCardCompactLabel(task)}</p>
                {PLANNING_TASK_STATUTS.map((st) => (
                    <button
                        key={st}
                        type="button"
                        role="menuitemradio"
                        aria-checked={(task.statutAvancement || 'a_faire') === st}
                        className={`mpr-statusmenu-item mpr-statusmenu-item--${st}${(task.statutAvancement || 'a_faire') === st ? ' is-current' : ''}`}
                        onClick={() => onPick(st)}
                    >
                        <span className="mpr-statusmenu-dot" aria-hidden="true" />
                        {PLANNING_TASK_STATUT_LABELS[st]}
                    </button>
                ))}
            </div>
        </>,
        document.body,
    );
};

export default PlanningStatusMenu;
